import {Requests, defaultErrorHandler} from './base'


function resultsRequest ($parent) {

  $parent.loading.isActive = true

  Requests.get('/results')
    .then(response => {
      $parent.results = response.data.results
      $parent.loading.isActive = false
      $parent.loading.completed = true
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}

function signatureRequest (transactionId, $parent) {
  return Requests.get(`/results/${transactionId}/signature`)
    .then(response => {
      let anchor = document.createElement('a')
      anchor.href = response.data.url
      anchor.click()
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}


function deleteRequest (transactionId, $parent) {
  return Requests.delete(`/results/${transactionId}`)
    .then(response => {
      resultsRequest($parent)
      $parent.$toast.open('削除が完了しました')
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}

function previewRequest (transactionId, param, $parent) {
  return Requests.get(`/results/${transactionId}/preview`, {data: param})
    .then(response => {
      return response.data
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}

export {resultsRequest, signatureRequest, previewRequest, deleteRequest}



// WEBPACK FOOTER //
// ./src/modules/request/results.js